<template>
<v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 mb-2 v-if="getFiltersChips">
        <Filters v-bind:filters="getFilters"></Filters>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-text class="pa-0 grey lighten-2 mb-3">
            <Counters v-bind:counters="['sources']" v-bind:filters="getFilters"></Counters>
          </v-card-text>
        </v-card>
      </v-flex>
       <v-flex xs12>
        <v-expansion-panel :value=expansionValue>
          <v-expansion-panel-content class="secondary accent--text" expand-icon="fa-angle-down accent--text">
            <div slot="header">
              <div style="float: left;margin-bottom: 0;line-height: 50px">Top Sources</div>
              <v-dialog style="float: right" v-model="articlesAndTweetsPerSourceDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-btn slot="activator" color="primary" class='ml-0 mr-2' style="width:30px" icon flat><v-icon style="font-size: 20px">fas fa-expand</v-icon></v-btn>
                <v-flex white style="height: 100%">
                  <v-toolbar dark color="accent" style="height: 65px">
                    <p class="headline mb-0">Top Sources</p>
                    <v-spacer></v-spacer>
                    <v-btn flat icon color="primary" style="float: right;" class="mx-0" @click.stop="snap($refs['FullArticlesAndTweetsPerSource'], 'FullArticlesAndTweetsPerSource')">
                      <v-icon>get_app</v-icon>
                    </v-btn>
                    <v-btn icon dark @click.native="articlesAndTweetsPerSourceDialog = false">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <v-flex id="FullArticlesAndTweetsPerSource" ref="FullArticlesAndTweetsPerSource" style="height: calc(100% - 65px);display:flex;align-items:center;justify-content:center;padding-top: 20px" v-if="articlesAndTweetsPerSourceDialog">
                    <ArticlesAndTweetsPerSource v-bind:options="{}" v-bind:filters="getFilters"></ArticlesAndTweetsPerSource>
                  </v-flex>
                </v-flex>
              </v-dialog>
              <v-btn style="float: right; width: 30px" flat icon color="primary" class="mx-0" @click.stop="snap($refs['ArticlesAndTweetsPerSource'], 'ArticlesAndTweetsPerSource')">
                <v-icon>get_app</v-icon>
              </v-btn>
            </div>
            <v-card style="height: 400px">
              <v-card-text id="ArticlesAndTweetsPerSource" ref="ArticlesAndTweetsPerSource" class="px-0" style="height: 100%">
                <ArticlesAndTweetsPerSource v-bind:options="{}" v-bind:filters="getFilters"></ArticlesAndTweetsPerSource>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-flex>
      <v-flex xs12>
        <v-toolbar class="elevation-1 secondary" >
          <v-toolbar-side-icon><v-icon>fa-newspaper</v-icon></v-toolbar-side-icon>
          <v-toolbar-title>Sources</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-flex xs3>
            <v-select
              v-model="sortBy"
              :items="articleSort"
              hide-details
              item-text="text"
              item-value="value"
              label="Sort By"
              :menu-props="{maxHeight:'900'}">
              <template slot="selection" slot-scope="{ item, tile }">
                <span><v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>{{ item.text}}</span>
              </template>
              <template slot="item" slot-scope="{ item, tile }">
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.text"></v-list-tile-title>
                </v-list-tile-content>
              </template>
            </v-select>
          </v-flex>
          <v-tooltip bottom>
            <v-avatar slot="activator">
              <v-icon v-bind:class="[orderBy === 'ASC' ? 'ascending' : 'descending']" @click="orderChange">arrow_downward</v-icon>
            </v-avatar>
            <span>Ascending / Descending Order</span>
          </v-tooltip>
        </v-toolbar>
        <v-card>
          <v-card-text class="pa-0">
            <center>
              <SourcesListing v-bind:options="{sortBy: sortBy, orderBy: orderBy}" v-bind:filters="getFilters"></SourcesListing>
            </center>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style>
  .ascending {
    transform: rotate(-180deg);
    transition: 0.2s all ease-in-out;
  }
  .descending {
    transform: rotate(0deg);
    transition: 0.2s all ease-in-out;
  }
</style>
<script>
import Filters from './Filters.vue'
import Counters from './Counters.vue'
import { snap } from '@/helpers/snapshots'
import { mapGetters, mapMutations } from 'vuex'
import ArticlesAndTweetsPerSource from './charts/ArticlesAndTweetsPerSource.vue'
import SourcesListing from './listings/SourcesListing.vue'

export default {
  data () {
    return {
      expansionValue: 0,
      articlesAndTweetsPerSourceDialog: false,
      articleView: [
        {color: 'blue lighten-2', icon: 'dashboard', text: 'Grid', value: 'grid'},
        {color: 'purple lighten-2', icon: 'dns', text: 'Tiles', value: 'tiles'}
      ],
      orderBy: 'DESC',
      sortBy: '_article_count',
      articleSort: [
        {color: 'orange lighten-2', icon: 'fa-newspaper', text: 'Articles', value: '_article_count'},
        {color: 'blue lighten-2', icon: 'fab fa-twitter', text: 'Tweet Count', value: '_tweeted_count'}
      ]
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn', 'currentUser']),
    ...mapGetters('filters', ['getFilters']),
    ...mapGetters('toggles', ['getFiltersChips'])
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('filters', ['setFilters', 'resetFilters']),
    snap,
    orderChange () {
      this.orderBy = this.orderBy === 'DESC' ? 'ASC' : 'DESC'
    }
  },
  components: {
    Filters,
    Counters,
    ArticlesAndTweetsPerSource,
    SourcesListing
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Sources.vue